var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row psa-box" }, [
      _c(
        "div",
        { staticClass: "col-lg-12" },
        [
          _c("center", [_c("h1", [_vm._v("資金決済法に基づく表示")])]),
          _vm._m(0),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [
      _c("h2", [_vm._v("（1）発行者の氏名、商号または名称")]),
      _c("p", [_vm._v("株式会社indent")]),
      _c("h2", [_vm._v("（2）利用可能金額等")]),
      _c("p", [
        _vm._v(
          " チャージFish（iOS）およびチャージFish（Android）のチャージ上限は以下のとおりです。 "
        ),
      ]),
      _c("p", [_vm._v("上限1億fish")]),
      _c("h2", [_vm._v("（3）使用期間または使用期限")]),
      _c("p", [
        _vm._v(
          "チャージFish（iOS）およびチャージFish（Android）：有効期限なし"
        ),
      ]),
      _c("p", [
        _vm._v(
          " ※無料配布Fishおよびウェブブラウザから購入したFish（チャージFish（Web))には最大180日の有効期限があります。有効期限は複数あり、発行条件等により異なります。詳しくはマイページをご確認ください。 "
        ),
      ]),
      _c("h2", [
        _vm._v(
          "（4）利用者からの苦情または相談を受ける窓口の所在地および連絡先"
        ),
      ]),
      _c("p", [
        _vm._v("所在地：東京都千代田区神田三崎町3-6-12 神田三崎町ビル4階"),
      ]),
      _c("p", [_vm._v("nola.cs@indent.co.jp")]),
      _c("h2", [_vm._v("（5）使用することができる施設または場所の範囲")]),
      _c("p", [_vm._v("Nola iOSアプリおよびAndroidアプリ")]),
      _c("h2", [_vm._v("（6）利用上の必要な注意")]),
      _c("ul", [
        _c("li", [
          _vm._v("「"),
          _c("a", { attrs: { href: "/membership", target: "_blank" } }, [
            _vm._v("Nola有料サービス利用規約"),
          ]),
          _vm._v("」をご覧ください。"),
        ]),
        _c("li", [
          _vm._v(
            " 購入アイテムによって1fish当たりの購入単価は変動します。詳しくは購入画面でご確認ください。 "
          ),
        ]),
        _c("li", [
          _vm._v(
            " 法令により認められる場合を除き、原則として、Fishの払い戻しはできません。 "
          ),
        ]),
        _c("li", [
          _vm._v(
            " Fishを他者に譲渡、転売、または現金に換金することはできません。 "
          ),
        ]),
        _c("li", [
          _vm._v(
            " チャージFish（iOS）、チャージFish（Android）は、購入したプラットフォーム上でのみ利用できます。詳細はマイページをご確認ください。 "
          ),
        ]),
      ]),
      _c("h2", [_vm._v("（7）未使用残高を知る方法")]),
      _c("p", [_vm._v("Nolaにログイン後、マイページでご確認いただけます。")]),
      _c("h2", [_vm._v("（8）約款等")]),
      _c("p", [
        _c("a", { attrs: { href: "/membership", target: "_blank" } }, [
          _vm._v("Nola有料サービス利用規約"),
        ]),
        _vm._v("をご確認ください。"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }